import Skeleton from "../../../components/Skeleton/Skeleton";
import useScreenSize from "../../../hooks/useScreenSize";
import styles from "../ResearchPage.module.scss";

const ResearchSkeleton = () => {
  const {
    cardsContainerStyleSkeleton,
    cardStyleSkeleton,
    imageStyleSkeleton,
    contentStyleSkeleton,
    skeletonImage,
    skeletonCategory,
    skeletonTitle,
    skeletonSubtitle,
    cardsContainerStyleSkeletonMobile,
    mobileCardSkeleton,
    mobileImageSkeleton,
    mobileContentSkeleton,
    mobileHeaderSkeleton,
    separatorSkeleton,
    skeletonIcon,
  } = styles;

  const { isMobile } = useScreenSize();

  if (isMobile)
    return (
      <div className={cardsContainerStyleSkeletonMobile}>
        {[1, 2, 3].map((i) => (
          <div key={i}>
            <div className={mobileCardSkeleton}>
              <Skeleton
                width="5.5rem"
                height="7.5rem"
                borderRadius="0.25rem"
                className={mobileImageSkeleton}
              />
              <div className={mobileContentSkeleton}>
                <div className={mobileHeaderSkeleton}>
                  <Skeleton
                    width="3.5rem"
                    height="0.75rem"
                    borderRadius="0.125rem"
                  />
                  <Skeleton
                    width="4.5rem"
                    height="0.75rem"
                    borderRadius="0.125rem"
                  />
                  <Skeleton
                    width="1rem"
                    height="1rem"
                    borderRadius="50%"
                    className={skeletonIcon}
                  />
                </div>
                <Skeleton width="100%" height="1rem" borderRadius="0.125rem" />
                <Skeleton
                  width="85%"
                  height="0.75rem"
                  borderRadius="0.125rem"
                />
              </div>
            </div>
            {i < 3 && <div className={separatorSkeleton} />}
          </div>
        ))}
      </div>
    );

  return (
    <div className={cardsContainerStyleSkeleton}>
      {[1, 2, 3].map((i) => (
        <div key={i} className={cardStyleSkeleton}>
          <div className={imageStyleSkeleton}>
            <div className={skeletonImage} />
          </div>
          <div className={contentStyleSkeleton}>
            <div className={skeletonCategory} />
            <div className={skeletonTitle} />
            <div className={skeletonSubtitle} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ResearchSkeleton;
